import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import WhyChooseUs from './WhyChooseUs';
import CaseStudies from './CaseStudies';
import Contact from './Contact';
import Footer from './Footer';
import ScrollProgress from './ScrollProgress';
import BackToTop from './BackToTop';

const LandingPage = () => {
  return (
    <div style={{ background: 'var(--bg-primary)' }}>
      <ScrollProgress />
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <CaseStudies />
      <Contact />
      <Footer />
      <BackToTop />
    </div>
  );
};

export default LandingPage;